import Row from '../Row';

export default [
    {
        component: Row,
        props: {
            id: 'cr_ceska-zemska-hranice',
            type: 'overlay',
            category: 'layer',
            className: 'js-layer',
            value: 'cr_ceska-zemska-hranice',
            name: 'Moravská zemská hranice',
            initial: false,
            icon: false,
        }
    },
    {
        component: Row,
        props: {
            id: 'cr_moravska-zemska-hranice',
            type: 'overlay',
            category: 'layer',
            className: 'js-layer',
            value: 'cr_moravska-zemska-hranice',
            name: 'Slezská zemská hranice',
            initial: false,
            icon: false,
        }
    },
    {
        component: Row,
        props: {
            id: 'cr_njo',
            type: 'overlay',
            category: 'layer',
            value: 'cr_njo',
            className: 'js-layer',
            name: 'Německé jazykové ostrovy v ČR',
            initial: false,
            icon: false,
        }
    }
];
